module.exports = __webpack_public_path__ + "media/right_glass_triangle.f660d9b9.wav";